/*
 * The acasa mark, taken from the logo-mark.svg on acasaimmobilien.de.
 *
 * Inlined rather than linked so it inherits the theme: the public asset hard-codes
 * #A21A26 and #878787, which disappears against the dark surface. The strokes are
 * bound to `--brand` and `--faint` instead, so the mark re-tints with the palette.
 */
export function LogoMark({ className = 'h-6' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 122 91"
      className={className}
      fill="none"
      role="img"
      aria-label="aCasaImmobilien"
    >
      <path
        d="M120.205 2.09163C124.911 7.73869 113.899 24.6799 95.64 39.9269C77.3812 55.174 58.7459 62.9858 54.04 57.3387C49.3341 51.6916 60.3459 34.7505 78.6047 19.5034C96.8635 4.25634 115.499 -3.55543 120.205 2.09163Z"
        fill="var(--brand)"
      />
      <path
        opacity="0.55"
        d="M72.2047 4.44457C76.5341 6.23281 75.3106 19.0328 69.3812 33.0563C63.5459 47.0799 55.2636 56.8681 50.9341 55.0799C46.6047 53.2916 47.8283 40.4916 53.7577 26.4681C59.593 12.4446 67.8753 2.65634 72.2047 4.44457Z"
        fill="var(--faint)"
      />
      <path
        d="M0.487061 61.2916C0.487061 61.2916 16.5812 43.0327 29.7577 46.7975C45.2871 51.4092 60.0635 76.821 86.3224 74.1857C110.228 72.1151 121.052 65.5269 121.052 65.5269C121.052 65.5269 103.264 85.668 80.9576 89.621C68.0635 91.8798 58.2753 89.9033 41.8988 71.5504C21.3812 46.3269 0.487061 61.2916 0.487061 61.2916Z"
        fill="var(--faint)"
      />
    </svg>
  )
}

/**
 * Mark plus wordmark. The public site sets "aCasa" in its display serif with the
 * "C" capitalised mid-word; that detail is what makes the wordmark recognisable,
 * so it is reproduced here rather than normalised to "Acasa".
 */
export function Wordmark() {
  return (
    <span className="flex items-center gap-2.5">
      <LogoMark className="h-7 w-auto shrink-0" />
      <span className="leading-none">
        <span className="font-display text-ink block text-[15px] tracking-tight">
          aCasa<span className="text-brand">Immobilien</span>
        </span>
        <span className="text-faint mt-1 block text-[10px] tracking-[0.14em] uppercase">
          Internes Werkzeug
        </span>
      </span>
    </span>
  )
}
